import type { FaqCategory } from "@/types/content";

/** Grouped FAQs for the dedicated FAQ page. */
export const faqCategories: FaqCategory[] = [
  {
    title: "Engagements",
    items: [
      {
        question: "How do engagements typically work?",
        answer:
          "Most partnerships start with a free consultation and a short discovery sprint to align on goals and scope, then move into design and delivery in tight, transparent loops. You work with a dedicated, senior squad — no hand-offs to junior teams.",
      },
      {
        question: "Do you work with existing teams and codebases?",
        answer:
          "Absolutely. We regularly embed with in-house teams, extend existing platforms and improve legacy systems — always leaving your team stronger than we found it.",
      },
      {
        question: "What engagement models do you offer?",
        answer:
          "Fixed-scope projects, ongoing retainers and team-extension models. We'll recommend the model that best fits your goals, budget and how you like to work.",
      },
    ],
  },
  {
    title: "Pricing & Budgets",
    items: [
      {
        question: "What does a project cost?",
        answer:
          "It depends on scope, but we'll give you a clear estimate within 48 hours of our first call. We're transparent about trade-offs so you can make informed decisions.",
      },
      {
        question: "Do you offer fixed pricing?",
        answer:
          "Yes. After discovery we can provide a fixed-scope estimate. For evolving products, a retainer often delivers better value and flexibility.",
      },
      {
        question: "Who owns the work you produce?",
        answer:
          "You do — entirely. You own the code, the data, the designs and the roadmap, with full documentation handed over to your team.",
      },
    ],
  },
  {
    title: "Timelines & Delivery",
    items: [
      {
        question: "How fast can you start?",
        answer:
          "We can usually kick off a discovery engagement within one to two weeks. Book a free consultation and we'll map the fastest responsible path to launch.",
      },
      {
        question: "How long does a typical project take?",
        answer:
          "We deliver in modules, so a first useful release is often live within a few months rather than after a single long project. Timelines are set together during planning.",
      },
      {
        question: "How do you keep us informed during delivery?",
        answer:
          "Radical transparency: regular demos, real-time progress visibility and open communication about decisions and trade-offs at every step.",
      },
    ],
  },
  {
    title: "After Launch",
    items: [
      {
        question: "What happens after launch?",
        answer:
          "Launch is the start, not the finish. We offer proactive monitoring, SLAs and ongoing optimisation so your product keeps improving and growing.",
      },
      {
        question: "Do you provide training and handover?",
        answer:
          "Yes. We run team walkthroughs, provide documentation and train admins and content owners so your team is confident running the product.",
      },
      {
        question: "Can the product scale as we grow?",
        answer:
          "We architect for growth from day one — modular systems that add capabilities and handle more users and data without a costly rebuild.",
      },
    ],
  },
];
